import { useState } from "react";
import { X } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
const FloatingReserveButton = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const isMobile = useIsMobile();
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);
  if (isMobile) {
    return null; // Don't show on mobile
  }
  return <>
      {/* Floating Reserve Button */}
      <div className="fixed top-1/2 right-8 transform -translate-y-1/2 z-40">
        <button onClick={openCalendlyModal} className="relative group cursor-pointer">
          <div className="absolute inset-0 bg-gradient-to-br from-[#E4683B] to-[#E05D2C] rounded-2xl blur-xl opacity-75 group-hover:opacity-100 transition-opacity animate-pulse"></div>
          
        </button>
      </div>

      {/* Calendly Modal */}
      {showCalendly && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors">
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" width="100%" height="100%" frameBorder="0" title="Schedule a meeting" />
          </div>
        </div>}
    </>;
};
export default FloatingReserveButton;